import React, { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Grid, Tabs, Tab, Box, Snackbar, Avatar } from "@material-ui/core";
import PropTypes from 'prop-types';
import AllAppsTable from "./Applications/AllAppsTable";
import AllAppsTile from "./Applications/AllAppsTile";
import AllAppsTbl from './Applications/AllAppsTbl';
import AllProdsTable from "./Products/AllProdsTable";
import AllProdsTile from "./Products/AllProdsTile";
import AllProdsTbl from "./Products/AllProdsTbl";
import CloudServiceLineCard from "./Cloud/CloudServiceLineCard";
import CloudServiceCard from "./Cloud/CloudServiceCard";
import SolutionLineCard from "./Solutions/SolutionLineCard";
import SolutionListCard from "./Solutions/SolutionListCard";
import SkeletonCardTable from './Skeleton/SkeletonCardTable';
import SkeletonCardTile from './Skeleton/SkeletonCardTile';
import translate from '../other/translate.json';
import Pagination from '@material-ui/lab/Pagination';
import KloBanksChoose from './KloBanksChoose';
import ChangeViewArray from './ChangeViewArray';
import Chip from '@material-ui/core/Chip';
import clsx from "clsx";
import SearchErr from './Errors/SearchErr';
import config from '../other/config';
import CustomSelect from './CustomSelect';
import utils from './../other/utils';
import axios from 'axios';

const { compareApps, getItemFromStorage } = utils
function union(setA) {
	let unionArr = []
	setA.forEach(el => {
		if (unionArr.includes(el)) {

		} else {
			unionArr.push(+el)
			// set = set + ',' + el
		}
	})
	return unionArr
}

const { serverAPI } = config;

function SearchContentResultSearch(props, ref) {

	const { setAppProd, searchResult, setAppBasket, currentSystems, systems, _currentSystems, accurateSearch, kloUser } = props;
	const language = localStorage.getItem('language') || 'Ru'
	const [appBasketSearch, _appBasketSearch] = useState(JSON.parse(localStorage.getItem('cartApp')) || [])
	const [cloudBasketSearch, _cloudBasketSearch] = useState(JSON.parse(localStorage.getItem('cartCloud')) || [])
	const classes = useStyles();
	const [value, setValue] = useState(0);
	// const view = localStorage.getItem('view') || 'table'
	let [checkAll, setCheckAll] = useState(false); // codeerr опять setCheckAll никуда
	const [page, setPage] = React.useState(1);
	const [pageProd, setPageProd] = React.useState(1);
	const [pageCloud, setPageCloud] = React.useState(1);
	const [pageSolution, setPageSolution] = React.useState(1);
	const [snackbar, _snackbar] = React.useState([false, '']);
	let [view, _view] = useState(localStorage.getItem('view') || 'table');
	const [cloudSnackbar, _cloudSnackbar] = React.useState([false, '']);
	const [solutionSnackbar, _solutionSnackbar] = React.useState([false, '']);
	const [prioritySnackbar, _prioritySnackbar] = React.useState([false, '']);
	const [pageTbl, setPageTbl] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(50);
	const [arrayTag, setArrayTags] = useState(JSON.parse(localStorage.getItem('AppsArrayTag')) || []);
	const [disablePriorityBtn, _disablePriorityBtn] = useState([]);
	const [sortingSelectVal, _sortingSelectVal] = useState('init');

	const changePage = (event, value) => {
		setPage(value);
		window.scrollTo(0, 0);
	};

	const changePageProd = (event, valueProd) => {
		setPageProd(valueProd);
		window.scrollTo(0, 0);
	};

	const changePageCloud = (event, valueCloud) => {
		setPageCloud(valueCloud);
		window.scrollTo(0, 0);
	};

	const changePageSolution = (event, valueSolution) => {
		setPageSolution(valueSolution);
		window.scrollTo(0, 0);
	};

	useImperativeHandle(ref, () => ({
		changePage: () => {
			changePage(undefined, 1);
			changePageCloud(undefined, 1);
			changePageProd(undefined, 1);
			changePageSolution(undefined, 1);
			_currentSystems([])
		}
	}));

	const handleChangeSolutionTabs = (event, newValue) => {
		setValue(newValue);
	};

	const setArrayTag = (arr) => {
		setPage(1)
		setArrayTags(arr)
		localStorage.setItem('AppsArrayTag', JSON.stringify(arr))
	}

	function clearChips() {
		setPage(1)
		setArrayTags([])
	}

	function closeSnackbar(event, reason) {
		if (reason === 'clickaway') {
			return;
		}
		_cloudSnackbar([false, '']);
		_solutionSnackbar([false, '']);
		_prioritySnackbar([false, '']);
	};

	function setCloudBasketSnackbar(apps, IDCloud) {
		CloudSnackbar(IDCloud)
		_cloudSnackbar([true, IDCloud]);
		setBasketCloud(apps, IDCloud)
	}

	const SolutionsTabs = withStyles(theme => ({
		root: {
			'& > div': {
				overflow: 'overlay',
				overflowX: 'auto !important',
				overflowY: 'hidden',
				scrollbarWidth: 'thin',

				[theme.breakpoints.down(696)]: {
					'& > div': {
						flexDirection: "column",

						'& > button > span': {
							alignItems: "baseline",
						}
					}
				}
			}
		},

		[theme.breakpoints.up(696)]: {
			indicator: {
				display: 'flex',
				justifyContent: 'center',
				backgroundColor: 'transparent',
				'& > span': {
					// maxWidth: 40,
					width: '100%',
					backgroundColor: '#24262A',
				},
			},
		}
	}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

	function NothingFound() {
		return (
			searchResult.Applications.length === 0 && searchResult.Products.length === 0 && searchResult.Clouds.length === 0 && searchResult.Solutions.length === 0
		)
	}

	const AllAppsTableM = () =>
		props.loading === true
			?
			<SkeletonCardTable />
			:
			NothingFound()
				?
				<SearchErr />
				:
				<AllAppsTable
					page={page}
					paginator={true}
					checkAll={false}
					setCheckAll={setCheckAll}
					type="applications"
					basket={true}
					basketChips={appBasketSearch}
					setAppBasket={setAppBasket}
					readLink={false}
					cardArr={filterApps(getArrAppsSorting(searchResult.Applications)).filter((elem, index) => { return index < page * 24 && index >= (page - 1) * 24 })}
					arrayTag={arrayTag}
					setArrayTag={setArrayTag}
					clearChips={clearChips}
					usname={props.usname}
					upPriority={upPrioritySnackbar}
					disablePriorityBtn={disablePriorityBtn}
					kloStatuses={props.kloStatuses}
					kloUser={props.kloUser}
					loadingKloStatuses={props.loadingKloStatuses}
					userCollection={props.userCollection}
					saveCollection={props.saveCollection}
				/>

	const AllAppsTileM = () =>
		props.loading === true
			?
			<SkeletonCardTile />
			:
			NothingFound()
				?
				<SearchErr />
				:
				<AllAppsTile
					page={page}
					paginator={true}
					checkAll={false}
					setCheckAll={setCheckAll}
					type="applications"
					basket={true}
					basketChips={appBasketSearch}
					setAppBasket={setAppBasket}
					readLink={false}
					cardArr={filterApps(getArrAppsSorting(searchResult.Applications)).filter((elem, index) => { return index < page * 24 && index >= (page - 1) * 24 })}
					arrayTag={arrayTag}
					setArrayTag={setArrayTag}
					clearChips={clearChips}
					usname={props.usname}
					upPriority={upPrioritySnackbar}
					disablePriorityBtn={disablePriorityBtn}
					kloStatuses={props.kloStatuses}
					kloUser={props.kloUser}
					loadingKloStatuses={props.loadingKloStatuses}
					userCollection={props.userCollection}
					saveCollection={props.saveCollection}
				/>

	const AllAppsTblM = () =>
		// NothingFound()
		// 	?
		// 	<SearchErr />
		// 	:
		<AllAppsTbl
			page={page}
			paginator={true}
			checkAll={false}
			setCheckAll={setCheckAll}
			type="applications"
			basket={true}
			basketChips={appBasketSearch}
			setAppBasket={setAppBasket}
			readLink={false}
			loading={props.loading}
			err={<SearchErr />}
			cardArr={filterApps(searchResult.Applications)}
			arrayTag={arrayTag}
			setArrayTag={setArrayTag}
			clearChips={clearChips}
			usname={props.usname}
			upPriority={upPrioritySnackbar}
			disablePriorityBtn={disablePriorityBtn}
			kloStatuses={props.kloStatuses}
			kloUser={props.kloUser}
			loadingKloStatuses={props.loadingKloStatuses}
			userCollection={props.userCollection}
			saveCollection={props.saveCollection}
			isSearch = {true}
		/>

	const AllApps = () => view === 'tile' ? AllAppsTableM() : view === 'table' ? AllAppsTileM() : AllAppsTblM()

	const setBasketCloud = (apps, IDCloud) => {
		const appBasketNew = JSON.parse(localStorage.getItem('cartApp')) || []
		const cloudBasketNew = JSON.parse(localStorage.getItem('cartCloud')) || []

		if (cloudBasketNew.some((element) => element === IDCloud) === true) {
			_cloudBasketSearch(cloudBasketSearch.filter(el_ => el_ !== IDCloud))
			localStorage.setItem('cartCloud', JSON.stringify(cloudBasketNew.filter(el_ => el_ !== IDCloud)))

			let arr_ = []
			appBasketNew.forEach(el => {
				if (apps.join('#').includes(el)) { } else {
					arr_.push(el)
				}
			})
			_appBasketSearch(arr_)
			localStorage.setItem('cartApp', JSON.stringify(arr_))

		} else {
			_cloudBasketSearch(cloudBasketNew.concat([IDCloud]))
			_appBasketSearch(union(appBasketNew.concat(apps)))

			localStorage.setItem('cartCloud', JSON.stringify(cloudBasketNew.concat([IDCloud])))
			localStorage.setItem('cartApp', JSON.stringify(union(appBasketNew.concat(apps))))
		}
	}

	const setBasketSolution = async (card) => {
		// const _card = await axios.get(`${serverAPI}/solutionsidv/${card.ID}/${lang}/0`)
		let card2 = card.AppsIDsNeeded.trim().split(/\s*,\s*/).map(Number)

		if (card2 && card2.length > 0) {
			let apps = card2;
			let basketApp = JSON.parse(localStorage.getItem('cartApp')) || [];
			let bA1 = basketApp.filter(item => apps.includes(item))

			if (bA1.length !== apps.length) {
				let unique = uniqueArr(basketApp.concat(apps));
				localStorage.setItem('cartApp', JSON.stringify(unique))
				props.saveCollection(props.userCollection.appBasket.concat(unique), 'app', 'cart')
				SolutionSnackbar()
				_solutionSnackbar([true, apps.length - bA1.length]);
			}
		}
	}

	function uniqueArr(arr) {
		let result = [];

		for (let str of arr) {
			if (!result.includes(str)) {
				result.push(str);
			}
		}

		return result;
	}

	const setView = (view) => {
		if (view === 'tbl') setPage(1);
		_view(view)
		localStorage.setItem('view', view)
	}

	const handleStrockList = (index) => {
		setView(index)
	};

	const filterApps = (apps) => {
		return currentSystems.length === 0 ? apps : apps.filter(elem => currentSystems.includes(elem.Title_catalog))
	}

	const renderChips = () => {
		const apps = searchResult.Applications
		if (systems.length > 0)

			return (
				<React.Fragment>
					<Chip
						className={clsx({
							[classes.filterChip]: currentSystems.length !== 0,
							[classes.filterChipSelected]: currentSystems.length === 0
						})}
						label={translate.Words['All' + language] + ' (' + apps.length + ')'}
						onClick={() => { _currentSystems([]) }}
					/>
					{systems.map((system, index) => {
						const isActiv = currentSystems.includes(system)
						return (
							<Chip
								className={clsx({
									[classes.filterChip]: !isActiv,
									[classes.filterChipSelected]: isActiv
								})}
								label={system + ' (' + apps.filter(elem => elem.Title_catalog === system).length + ')'}
								onClick={() => {
									let newSystems = currentSystems.includes(system) ? currentSystems.filter(elem => elem !== system) : currentSystems.concat(system);
									_currentSystems(newSystems.length === systems.length && newSystems.length !== 1 ? [] : newSystems);
									setPage(1)
								}}
							/>
						)
					})}
				</React.Fragment>
			)
	}

	useEffect(() => {
		if (window.innerWidth < 1366) {
			setView('tile')
		}
	}, [window.innerWidth]);

	useEffect(() => {
		let url = window.location.search.indexOf('&t=', 0)
		let num = props.menu.find(category => category.ID_Category === 4 && category.isArchive === 0) ? 2 : 3;
		if (url !== -1) {
			let tab = window.location.search.at(url + 3, 1);
			handleChangeSolutionTabs('', tab - num);
		}
	}, []);

	// useEffect(() => {
	// 	if (accurateSearch) {
	// 	changePage(0);
	// 	changePageProd(0);
	// 	changePageCloud(0);
	// 	changePageSolution(0);
	// 	}
	// }, [accurateSearch]);

	function upPrioritySnackbar(ResearchMarketMails, codeasvul) {
		_prioritySnackbar([true, translate.Words[`HasBeenRaised${language}`]])
		upPriority(ResearchMarketMails, codeasvul)
	}

	async function upPriority(ResearchMarketMails, codeasvul) {
		let toJson = ResearchMarketMails && ResearchMarketMails.length > 1 ? JSON.parse(ResearchMarketMails) : {}
		toJson[`${props.usname.email}`] = 1;

		_disablePriorityBtn(disablePriorityBtn.concat(codeasvul))

		// console.log(disablePriorityBtn, disablePriorityBtn.concat(codeasvul));

		const result = await axios.post(`${serverAPI}/uppriority`, { mails: JSON.stringify(toJson), asvul: codeasvul })
		if (result) { } // codeerr пока заглушка
	}


	function CloudSnackbar(id) {
		return (
			<div>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={cloudSnackbar[0]}
					autoHideDuration={1000}
					onClose={closeSnackbar}
					// message="Приложение доавлено в корзину"
					className={classes.root}
				>
					<Grid
						container
						direction="row"
						justify="flex-start"
						alignItems="center"
						className={classes.snackbarPostroot}
					>
						<Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
							<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
							</svg>
						</Avatar>
						{
							cloudBasketSearch.includes(cloudSnackbar[1])
								?
								<Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>
									{translate.Words[`AdtoCartService_${language}`]} </Typography>
								:
								<Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>
									{translate.Words[`RemoveCartService_${language}`]}  </Typography>
						}
					</Grid>
				</Snackbar>
			</div>
		)
	}

	function SolutionSnackbar() {
		return (
			<div>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={solutionSnackbar[0]}
					autoHideDuration={1000}
					onClose={closeSnackbar}
					// message="Приложение доавлено в корзину"
					className={classes.root}
				>
					<Grid
						container
						direction="row"
						justify="flex-start"
						alignItems="center"
						className={classes.snackbarPostroot}
					>
						<Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
							<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
							</svg>
						</Avatar>

						<Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>
							{translate.Words[`ApplicationsHaveBeenAddedToTheCart${language}`] + ' ' + solutionSnackbar[1]}
						</Typography>
					</Grid>
				</Snackbar>
			</div>
		)
	}

	function PrioritySnackbar() {
		return (
			<div>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={prioritySnackbar[0]}
					autoHideDuration={1000}
					onClose={closeSnackbar}
					// message="Приложение доавлено в корзину"
					className={classes.root}
				>
					<Grid
						container
						direction="row"
						justify="flex-start"
						alignItems="center"
						className={classes.snackbarPostroot}
					>
						<Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
							<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
							</svg>
						</Avatar>
						<Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>
							{prioritySnackbar[1]}
						</Typography>
					</Grid>
				</Snackbar>
			</div>
		)
	}

	const getSearchTitle = () => {
		if (!['', undefined].includes(props.keyboardLayout) && language === 'Ru') {
			return <Typography className={classes.Title3}>По запросу "{props.freezedFindText}" ничего не найдено. Показаны результаты по запросу "{props.keyboardLayout}". <br /> {translate.Words[`Matchesfound${language}`] + ' '}{searchResult.Applications.length + searchResult.Clouds.length + searchResult.Products.length + searchResult.Solutions.length}</Typography>
		} else if (window.location.search.indexOf('&t=', 0) !== -1) {
			return <Typography className={classes.Title3}>{translate.Words[`Matchesfound${language}`] + ' '}{searchResult.Clouds.length + searchResult.Products.length + searchResult.Solutions.length}</Typography>
		} else {
			return <Typography className={classes.Title3}>{translate.Words[`Matchesfound${language}`] + ' '}{searchResult.Applications.length + searchResult.Clouds.length + searchResult.Products.length + searchResult.Solutions.length}</Typography>
		}
	}

	const foundCategory = (idx, idCategory, name, section, index) => {
		if (props.menu.find(category => category.ID_Category === idCategory && category.isArchive === 0)) {
			return (
				<Tab label={translate.Words[`${name}${language}`] + ' ' + searchResult[section].length || 0} {...a11yProps(idx)} />
			);
		}
	}

	const getArrAppsSorting = (arrApps) => {
		if (sortingSelectVal === 'init') {
			return props.searchResult.Applications//arrApps
		} else {		
			let arrAppsNew = [...arrApps];

			if (sortingSelectVal.at(-1) === 'A') {
				if (sortingSelectVal.slice(0, -1) === 'codeAsvulSort') {
					return /*arrAppsNew = */arrAppsNew.sort(compareApps)
				} else {
					return /*arrAppsNew = */ arrAppsNew.sort((a, b) => a[sortingSelectVal.slice(0, -1)] < b[sortingSelectVal.slice(0, -1)] ? 1 : -1)
				}
			} else {
				if (sortingSelectVal.slice(0, -1) === 'codeAsvulSort') {
					return /*arrAppsNew = */ arrAppsNew.sort(compareApps).reverse()
				} else {
					return /*arrAppsNew = */ arrAppsNew.sort((a, b) => a[sortingSelectVal.slice(0, -1)] > b[sortingSelectVal.slice(0, -1)] ? 1 : -1)
				}
			}

			//return arrAppsNew
		}
	}

	return (
		<Grid container direction="column" justify="flex-start" alignItems="center" /* style={{ outline: '1px solid red' }} */>
			<Grid item container alignItems="center" justify="space-between" className={props.keyboardLayout !== '' ? classes.TitleCntr : value === 0 ? classes.TitleCntr3 : classes.TitleCntr2}>
				<Grid item>
					{getSearchTitle()}
				</Grid>

				<Grid item container direction="row" justify="space-between">
					<Grid item
					// style={{ minWidth: 500 }} CTG-509 executable thing
					>
						<SolutionsTabs
							value={value}
							onChange={handleChangeSolutionTabs}
							aria-label="simple tabs example"
							id='SearchResultTabs'
						>
							{window.location.search.indexOf('&t=', 0) !== -1 ? null : foundCategory(0, 3, 'Applications_', 'Applications')}
							{foundCategory(1, 2, 'Products', 'Products')}
							{foundCategory(2, 4, 'CloudServices', 'Clouds')}
							{foundCategory(3, 1, 'Solution', 'Solutions')}
						</SolutionsTabs>
					</Grid>

					<Grid item container className={classes.cntrChangeView}>
						<Grid item style={{ width: 224, display: window.location.search.indexOf('&t=', 0) !== -1 || value !== 0 || searchResult.Applications?.length < 1 || view === 'tbl' ? 'none' : 'block' }}>
							<CustomSelect
								data={ 
									[
										{ id: 'codeAsvulSortA', name: language === 'Ru' ? 'По коду \u{1F856}' : 'By code \u{1F856}' }, // 🡖
										{ id: 'codeAsvulSortD', name: language === 'Ru' ? 'По коду \u{1F855}' : 'By code \u{1F855}' }, // 🡕
										{ id: 'sortingdatestartsaleD', name: language === 'Ru' ? 'По дате выпуска \u{1F855}' : 'By release date \u{1F855}' },
										{ id: 'sortingdatestartsaleA', name: language === 'Ru' ? 'По дате выпуска \u{1F856}' : 'By release date \u{1F856}' },
										{ id: 'versionD', name: language === 'Ru' ? 'По версии \u{1F855}' : 'By version \u{1F855}' },
										{ id: 'versionA', name: language === 'Ru' ? 'По версии \u{1F856}' : 'By version \u{1F856}' },
										{ id: 'init', name:language === 'Ru' ?  'Рекомендуемое' : 'Recommended'}
									]
								}
								value={sortingSelectVal}
								tooltip={translate.Words[`Sorting_${language}`]}
								defaultValue={sortingSelectVal}
								func={(e) => _sortingSelectVal(e.target.value)}
							/>
						</Grid>

						<Grid item className={classes.cntrChangeViewArray}>
							<ChangeViewArray
								selected={view === 'tile' ? 1 : view === 'table' ? 0 : 2}
								handleView={handleStrockList}
								bank={props.bank}
								page={window.innerWidth > 1365 ? 'applist' : ''}
								disabled2={value !== 0 && value !== 1}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>

			<Grid item container>
				{
					window.location.search.indexOf('&t=', 0) === -1
						?
						<TabPanel value={value} index={0} key={'AllAppsTabPanel'} >
							{NothingFound()
								?
								null
								:
								<Grid container direction='row' style={{ margin: '5px 12px 0 ', minHeight: 49 }}>
									{renderChips()}
								</Grid>
							}

							{AllApps()}

							{
								view === 'tbl' || filterApps(searchResult.Applications).length === 0
									?
									null
									:
									<Grid item container style={{ display: Math.trunc((filterApps(searchResult.Applications).length - 1) / 24) > 0 || (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? '' : 'none', marginTop: 24, height: 32, paddingLeft: 12, alignItems: 'center' }} >
										{
											Math.trunc((filterApps(searchResult.Applications).length - 1) / 24) > 0
												?
												<Pagination className={classes.newPagination} id='pagination-js' style={{ 'visible': 'hidden' }} count={Math.trunc((filterApps(searchResult.Applications).length - 1) / 24) + 1} siblingCount={window.innerWidth < 696 ? 0 : 1} page={page} onChange={changePage} />
												:
												null
										}
										<KloBanksChoose kloUser={props.kloUser} _kloUser={props._kloUser} delta={Math.trunc((filterApps(searchResult.Applications).length - 1) / 24) === 0 && (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? 0.15 : undefined} />
									</Grid>
							}
							{
								view === 'tbl' || filterApps(searchResult.Applications).length === 0
									?
									null
									:
									<Grid item id='paginationContainer-js' container style={{ display: Math.trunc((filterApps(searchResult.Applications).length - 1) / 24) > 0 || (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? '' : 'none', marginTop: 24, height: 64, position: 'fixed', bottom: '0px', background: '#F4F5FB', padding: '0 0 0 12px', alignItems: 'center' }} >
										{
											Math.trunc((filterApps(searchResult.Applications).length - 1) / 24) > 0
												?
												<Pagination id='pagination2-js' className={classes.newPagination} count={Math.trunc((filterApps(searchResult.Applications).length - 1) / 24) + 1} siblingCount={window.innerWidth < 696 ? 0 : 1} page={page} onChange={changePage} />
												:
												null
										}
										<KloBanksChoose kloUser={props.kloUser} _kloUser={props._kloUser} delta={Math.trunc((filterApps(searchResult.Applications).length - 1) / 24) === 0 && (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? 0.15 : undefined} />
									</Grid>
							}

							{PrioritySnackbar()}
						</TabPanel>
						:
						null
				}

				{/* ===== ПРОДУКТЫ =============== */}

				<TabPanel value={value}
					index={window.location.search.indexOf('&t=', 0) !== -1 ? 0 : 1}
					key={'AllAppsTabPanel1'}>
					{
						<React.Fragment>
							{view === 'tile'
								?
								props.loading === true
									?
									<SkeletonCardTable />
									:
									NothingFound()
										?
										<SearchErr />
										:
										<AllProdsTable
											key={'AllProdsTable'}
											setAppBasket={setAppProd}
											setCheckAll={setCheckAll}
											// prodBasketChips={prodBasketChips}
											// setStateCard={setStateCard} 
											lang={language}
											// cardArr={searchResult.Products}
											cardArr={(searchResult.Products).filter((elem, index) => { return index < pageProd * 24 && index >= (pageProd - 1) * 24 })}
											IsRu={language === 'Ru'}
											userCollection={props.userCollection}
											saveCollection={props.saveCollection}
										/>
								:
								view === 'table'
									?
									props.loading === true
										?
										<SkeletonCardTile />
										:
										NothingFound()
											?
											<SearchErr />
											:
											<AllProdsTile
												key={'AllProdsTile'}
												// setStateCard={setStateCard} 
												lang={language}
												setAppBasket={setAppProd}
												// prodBasketChips={prodBasketChips}
												setCheckAll={setCheckAll}
												// cardArr={searchResult.Products}
												cardArr={(searchResult.Products).filter((elem, index) => { return index < pageProd * 24 && index >= (pageProd - 1) * 24 })}
												IsRu={language === 'Ru'}
												userCollection={props.userCollection}
												saveCollection={props.saveCollection}
											/>
									:
									<AllProdsTbl
										key={'AllProdsTbl'}
										// setStateCard={setStateCard} 
										lang={language}
										setAppBasket={setAppProd}
										// prodBasketChips={prodBasketChips}
										setCheckAll={setCheckAll}
										cardArr={searchResult.Products}
										IsRu={language === 'Ru'}
										page={pageTbl}
										setPage={setPageTbl}
										rowsPerPage={rowsPerPage}
										setRowsPerPage={setRowsPerPage}
										userCollection={props.userCollection}
										saveCollection={props.saveCollection}
										isSearch = {true}
									/>
							}

							{
								view === 'tbl'
									?
									null
									:
									<Grid item container style={{ display: Math.trunc(((searchResult.Products).length - 1) / 24) > 0 ? '' : 'none', marginTop: 24, paddingLeft: 13, alignItems: 'center' }} >
										<Pagination className={classes.newPagination} id='pagination-js' style={{ 'visible': 'hidden' }} count={Math.trunc(((searchResult.Products).length - 1) / 24) + 1} page={pageProd} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePageProd} />
									</Grid>
							}
							{
								view === 'tbl'
									?
									null
									:
									<Grid item id='paginationContainer-js' container style={{ display: Math.trunc(((searchResult.Products).length - 1) / 24) > 0 ? '' : 'none', marginTop: 24, height: 64, position: 'fixed', bottom: '0px', background: '#F4F5FB', paddingLeft: 13, alignItems: 'center' }} >
										<Pagination className={classes.newPagination} count={Math.trunc(((searchResult.Products).length - 1) / 24) + 1} page={pageProd} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePageProd} />
									</Grid>
							}
						</React.Fragment>
					}
				</TabPanel>

				{/* =============== ПРОДУКТЫ ===== */}

				{/* ===== ОБЛАЧНЫЕ СЕРВИСЫ =============== */}

				<TabPanel value={value} index={/* 2 */ 3}>
					{
						view === 'tile'
							?
							props.loading === true
								?
								<SkeletonCardTable />
								:
								NothingFound()
									?
									<SearchErr />
									:
									<CloudServiceCard
										key={'CloudServiceCard'}
										cloudBasket={cloudBasketSearch}
										// cardArr={searchResult.Clouds}
										cardArr={(searchResult.Clouds).filter((elem, index) => { return index < pageCloud * 24 && index >= (pageCloud - 1) * 24 })}
										setBasketCloud={setCloudBasketSnackbar}
										way={'search'}
									/>
							:
							props.loading === true
								?
								<SkeletonCardTile />
								:
								NothingFound()
									?
									<SearchErr />
									:
									<CloudServiceLineCard
										cloudBasket={cloudBasketSearch}
										// cardArr={searchResult.Clouds}
										cardArr={(searchResult.Clouds).filter((elem, index) => { return index < pageCloud * 24 && index >= (pageCloud - 1) * 24 })}
										setBasketCloud={setCloudBasketSnackbar}
										way={'search'}
									/>
					}

					<Grid item container style={{ display: Math.trunc(((searchResult.Clouds).length - 1) / 24) > 0 ? '' : 'none', marginTop: 24, paddingLeft: 13, alignItems: 'center' }} >
						<Pagination className={classes.newPagination} id='pagination-js' style={{ 'visible': 'hidden' }} count={Math.trunc(((searchResult.Clouds).length - 1) / 24) + 1} page={pageCloud} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePageCloud} />
					</Grid>

					<Grid item id='paginationContainer-js' container style={{ display: Math.trunc(((searchResult.Clouds).length - 1) / 24) > 0 ? '' : 'none', marginTop: 24, height: 64, position: 'fixed', bottom: '0px', background: '#F4F5FB', paddingLeft: 13, alignItems: 'center' }} >
						<Pagination className={classes.newPagination} count={Math.trunc(((searchResult.Clouds).length - 1) / 24) + 1} page={pageCloud} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePageCloud} />
					</Grid>

					{CloudSnackbar()}
				</TabPanel>

				{/* =============== ОБЛАЧНЫЕ СЕРВИСЫ ===== */}

				{/* ===== ГОТОВЫЕ РЕШЕНИЯ =============== */}

				<TabPanel
					value={value}
					index={props.menu.find(category => category.ID_Category === 4 && category.isArchive === 0) ? 3 : window.location.search.indexOf('&t=', 0) === -1 ? 2 : 1}
				>
					{view === 'tile'
						?
						props.loading === true
							?
							<SkeletonCardTable />
							:
							NothingFound()
								?
								<SearchErr />
								:
								<SolutionListCard
									// cardArr={searchResult.Solutions}
									cardArr={(searchResult.Solutions).filter((elem, index) => { return index < pageSolution * 24 && index >= (pageSolution - 1) * 24 })}
									way={'search'}
									setBasketSolution={setBasketSolution}
									saveCollection={props.saveCollection}
								/>
						:
						props.loading === true
							?
							<SkeletonCardTile />
							:
							NothingFound()
								?
								<SearchErr />
								:
								<SolutionLineCard
									// cardArr={searchResult.Solutions}
									cardArr={(searchResult.Solutions).filter((elem, index) => { return index < pageSolution * 24 && index >= (pageSolution - 1) * 24 })}
									way={'search'}
									setBasketSolution={setBasketSolution}
								/>
					}

					<Grid item container style={{ display: Math.trunc(((searchResult.Solutions).length - 1) / 24) > 0 ? '' : 'none', marginTop: 24, paddingLeft: 13, alignItems: 'center' }} >
						<Pagination className={classes.newPagination} id='pagination-js' style={{ 'visible': 'hidden' }} count={Math.trunc(((searchResult.Clouds).length - 1) / 24) + 1} page={pageSolution} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePageSolution} />
					</Grid>

					<Grid item id='paginationContainer-js' container style={{ display: Math.trunc(((searchResult.Solutions).length - 1) / 24) > 0 ? '' : 'none', marginTop: 24, height: 64, position: 'fixed', bottom: '0px', background: '#F4F5FB', paddingLeft: 12, alignItems: 'center' }} >
						<Pagination className={classes.newPagination} count={Math.trunc(((searchResult.Clouds).length - 1) / 24) + 1} page={pageSolution} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePageSolution} />
					</Grid>

					{SolutionSnackbar()}
				</TabPanel>

				{/* =============== ГОТОВЫЕ РЕШЕНИЯ ===== */}
			</Grid>
		</Grid >
	);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Grid
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
			style={{ width: '100%' }}
		>
			{value === index && (
				<Box p={3} style={{ padding: 0, backgroundColor: 'transparent' }} >
					<Grid container spacing={3} style={{ marginTop: 18, /* outline: '1px solid green' */ }}>{children}</Grid>
				</Box>
			)}
		</Grid>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `search-result-tab-${index}`,
		'aria-controls': `search-result-tabpanel-${index}`,
	};
}

const useStyles = makeStyles(theme => ({
	Title: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '40px',
		lineHeight: '50px',
		color: '#000000'
	},

	search: {
		position: 'relative',
		borderRadius: 24,
		backgroundColor: 'transparent',
		marginLeft: 0,
		marginRight: theme.spacing(1),
		width: 'auto',
		height: 48,

		[theme.breakpoints.down(1366)]: {
			backgroundColor: 'transparent'
		}
	},

	searchIcon: {
		padding: theme.spacing(0, 2),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#8987A2',
		paddingLeft: 0,
		// right: 0
	},
	newPagination: {
		display: 'flex',
		alignItems: 'center'
	},

	// inputRoot: {
	// 	color: '#8987A2',
	// 	// outline: '1px solid purple',
	// 	width: '100%'
	// },

	// inputFocused: {
	// 	color: '#8987A2',
	// 	// outline: '1px solid green',
	// 	width: '100%'
	// },

	// inputInput: {
	// 	padding: theme.spacing(1, 2),
	// 	// vertical padding + font size from searchIcon
	// 	paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
	// 	paddingRight: 48,
	// 	transition: theme.transitions.create('width'),
	// 	width: '100%',
	// 	height: 32,

	// 	[theme.breakpoints.up(1366)]: {
	// 		// width: 0,
	// 		'&:focus': {
	// 			width: '100%',
	// 		},
	// 	},

	// 	[theme.breakpoints.down(1366)]: {
	// 		// width: 0,
	// 		'&:focus': {
	// 			// width: 207,
	// 			width: '100%',
	// 		},
	// 	},
	// 	color: '#8987A2'
	// },

	inputCloseBtn: {
		position: 'absolute',
		top: 0,
		right: 0,

		// [theme.breakpoints.up(1365)]: {
		// 	display: 'none'
		// }
	},

	// inputCloseBtnHide: {
	// 	display: 'none'
	// },

	Title3: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '24px',
		lineHeight: '32px',
		color: '#24262A'
	},

	cntrChangeView: {
		marginLeft: 8,
		maxWidth: 396,
		justifyContent: 'flex-end',

		[theme.breakpoints.down(1366)]: {
			maxWidth: 224,
		},

		[theme.breakpoints.down(1032)]: {
			marginLeft: 0,
			marginTop: 16,
		},

		[theme.breakpoints.down(696)]: {
			marginLeft: 0,
			marginTop: 12,
		},
	},

	cntrChangeViewArray: {
		paddingLeft: 12,

		[theme.breakpoints.down(1366)]: {
			display: 'none'
		}
	},

	snackbarPostroot: {
		padding: 24,
		borderRadius: '16px',
		background: 'rgba(60, 60, 86, 0.9)',
	},

	filterChip: {
		margin: 6,
		background: '#FFFFFF',
		color: '#8987A2',

		"&:focus": {
			background: '#FFFFFF',
		}
	},

	filterChipSelected: {
		margin: 6,
		background: 'rgb(129, 211, 157)',
		color: '#FFFFFF',

		"&:focus": {
			background: 'rgb(129, 211, 157)',
		}
	},

	[theme.breakpoints.down(696)]: {
		TitleCntr: {
			height: "auto",
		},

		TitleCntr2: {
			height: "188px",
		},

		TitleCntr3: {
			height: "236px",
		},
	}
}));

export default forwardRef(SearchContentResultSearch)